import { render, staticRenderFns } from "./AsyncDeptTree.vue?vue&type=template&id=4337940d&"
import script from "./AsyncDeptTree.vue?vue&type=script&lang=js&"
export * from "./AsyncDeptTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports